import React from 'react'
import filterStylesComponents from '../../../../../assets/filterComponentsStyles'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputBase,
  MenuItem,
  TextField,
  TextareaAutosize,
  Typography,
} from '@material-ui/core'
import { createDescription, transferLead } from '../../PanelActions'
import colors from '../../../../../assets/colors'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { mdiClose } from '@mdi/js'
import Icon from '@mdi/react'

const ModalTransferOs = ({
  open = false,
  handleOpen = () => {},
  leadId = '',
}) => {
  const attendants = useSelector(state => state.crmPanel.attendants)

  const filterStyles = filterStylesComponents()
  const dispatch = useDispatch()
  const history = useHistory()

  const handleSubmit = async e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    try {
      const resp = await dispatch(transferLead(leadId, values))

      if (resp) {
        history.push('/crm/panel')
      }
    } catch (e) {
      //
    }
  }

  return (
    <Dialog open={open} onClose={handleOpen} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography style={{ fontSize: '20px' }}>Transferir Os</Typography>
          </Grid>

          <Grid item>
            <IconButton onClick={handleOpen}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            select
            name="attendant_id"
            variant="standard"
            fullWidth
            label="Selecione um atendente"
          >
            <MenuItem value="">Selecione...</MenuItem>

            {attendants?.map((user, index) => (
              <MenuItem value={user?.id} key={index}>
                {user?.name}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>

        <DialogActions>
          <Grid container alignItems="center" justifyContent="center">
            <Grid item>
              <Button
                type="submit"
                className={filterStyles.btnAdd}
                style={{ textTransform: 'none' }}
              >
                Salvar
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default ModalTransferOs
